import { FC, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { OkrActivityI } from '~src/interfaces/okrActivity.interface';
import SvgIcon from '~src/shared/SvgIcon';
import LoadingSpinner from '~src/shared/loadingSpinner/LoadingSpinner';
import { okrApi } from '~src/services/ApiController';
import { StoreI } from '~src/rootReducer';
import { getSystemLocale } from '~src/services/session';
import SimpleToggle from '~src/shared/form/simpleToggle/SimpleToggle';

import { ListHeader, ListTitle } from './searchableActivityList.sc';
import ActivityList from './ActivityList';

interface OwnProps {
  initialActivities?: OkrActivityI[] | null;
  type: 'objective' | 'key_result';
  id: string;
}

interface StateProps {
  systemLanguage: string;
}

type Props = OwnProps & StateProps;

const ToggleableActivityList: FC<Props> = props => {
  const [activities, setActivities] = useState(props.initialActivities || []);
  const [searchLoading, setSearchLoading] = useState(true);

  const fetchActivities = async () => {
    setSearchLoading(true);
    const res = await okrApi.get(`activities/${props.type}/${props.id}?lang=${props.systemLanguage}`);
    setActivities(res.data);
    setSearchLoading(false);
  };

  useEffect(() => {
    fetchActivities();
  }, [props.id]);

  const [showList, setShowList] = useState(false);

  const onChangeToggle = (isToggled: boolean) => {
    setShowList(isToggled);
    if (isToggled) {
      fetchActivities();
    }
  };

  const [t] = useTranslation();

  return (
    <div>
      <ListHeader>
        <ListTitle>
          <SvgIcon name="iconArrowClock" />
          <span data-translation="okr.activities.title">{t('okr.activities.title')}</span>
        </ListTitle>
        <SimpleToggle onChange={onChangeToggle} />
      </ListHeader>
      {showList && (
        <>{searchLoading ? <LoadingSpinner color="white" /> : <ActivityList activities={activities} />}</>
      )}
    </div>
  );
};

const mapStateToProps = (state: StoreI): StateProps => ({
  systemLanguage: getSystemLocale(state),
});

const ToggleableActivityListConnected = connect(mapStateToProps)(ToggleableActivityList);
export default ToggleableActivityListConnected;
